import React, { FC, useLayoutEffect, useState } from "react";
import { A, Span } from "../../components/Text/Text";
import { UserRoleE } from "../../models/enums";
import { useAppSelector } from "../../store/hooks";
import { selectCurrentUser } from "../../store/selectors/authSelectors";
import { selectDeliveryWizardStep } from "../../store/selectors/deliveryWizardSelector";
import { useNonDesktopViewport } from "../../utils/hooks/useNonDesktopViewport";
import StepsNavigation from "../CampaignWizard/components/StepsNavigation/StepsNavigation";
import { getHeaderTitle } from "./helpers/getHeaderTitle";
import { WizardModeE, WizardTypeE } from "./models";

import styles from "./styles.module.scss";

type WizardHeaderPropTypes = {
  mode: WizardModeE;
  type: WizardTypeE;
  campaignId?: number;
  isShortEdit?: boolean;
};

const WizardHeader: FC<WizardHeaderPropTypes> = (props) => {
  const { mode, type, campaignId, isShortEdit } = props;
  const currentStep = useAppSelector(selectDeliveryWizardStep);
  const isCompactHeader = useNonDesktopViewport();
  const [showHint, setShowHint] = useState(!isCompactHeader);
  const user = useAppSelector(selectCurrentUser);

  useLayoutEffect(() => {
    setShowHint(!isCompactHeader);
  }, [isCompactHeader]);

  const toggleShowHint = (e) => {
    if (isCompactHeader && e.target.tagName !== "A") {
      setShowHint((prev) => !prev);
    }
  };

  const guideLink =
    user?.role === UserRoleE.Broadcaster
      ? "https://docs.google.com/presentation/d/e/2PACX-1vReW0ECVGKpa-jyKEzd3fbDLglQFnhnVgXGGqL1fYJwNII3SswRjXdUP5MDA6I0eY75plscLf_bLq8v/pub?start=false&loop=false&delayms=3000"
      : "https://docs.google.com/presentation/d/e/2PACX-1vQmj_6klYpGK8nFlC_oBNXxEWsW5pZnK5dH-wiV5tz2Xcs3Q06ZpKeB85flU1Id_frfvrG442POj5GL/pub?start=false&loop=false&delayms=60000&slide=id.p";

  const Hint = () => (
    <div className={styles.subHeader} onClick={toggleShowHint}>
      <Span>Have you already read the guide to creating a new campaign?</Span>
      <A href={guideLink}>Take a guide tour</A>
    </div>
  );

  return (
    <div className={styles.wizardHeader}>
      <h1>
        <span>
          <Span>{getHeaderTitle(mode, type)}</Span>{" "}
          {(mode === WizardModeE.Edit &&
            type === WizardTypeE.Delivery &&
            campaignId) ||
            ""}
        </span>
        {type === WizardTypeE.Campaign && isCompactHeader && (
          <span className={styles.helpIcon} onClick={toggleShowHint} />
        )}
      </h1>
      {mode === WizardModeE.Create &&
        type === WizardTypeE.Campaign &&
        showHint && <Hint />}
      {type === WizardTypeE.Delivery && !isShortEdit && (
        <StepsNavigation currentStep={currentStep - 1} isNewWizard />
      )}
    </div>
  );
};

export default WizardHeader;
